import { IWPImage } from "@/src/types";
import { MainSection } from "@/styles/global";
import React from "react";
import S from "./VideoHero.styled";
import PlayIcon from "assets/play.svg";
import PauseIcon from "assets/pause.svg";
import { toGatsbyImage } from "@/src/helpers";

export interface VideoHeroProps {
  mediaType: string;
  image: IWPImage;
  video: {
    mediaItemUrl: string;
    mimeType: string;
  };
}

const VideoHero: React.FC<VideoHeroProps> = ({ mediaType, image, video }) => {
  const imageData = toGatsbyImage(image);
  const [play, setPlay] = React.useState(true);

  React.useEffect(() => {
    const videoElement = document.getElementById(
      "my-video"
    ) as HTMLVideoElement;
    if (videoElement) {
      if (play) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    }
  }, [play]);

  return (
    <MainSection>
      {imageData && mediaType === "image" && (
        <S.BackgroundImage image={imageData} alt={image.altText || ""} />
      )}
      {mediaType === "video" && (
        <S.VideoContainer>
          <video id="my-video" loop muted playsInline autoPlay>
            <source src={video.mediaItemUrl} type={video.mimeType} />
          </video>
        </S.VideoContainer>
      )}
      <S.Inner>
        {mediaType === "video" && (
          <>
            {play && (
              <S.Button onClick={() => setPlay(!play)}>
                Pausa video <PauseIcon />
              </S.Button>
            )}
            {!play && (
              <S.Button onClick={() => setPlay(!play)}>
                Spela video <PlayIcon />
              </S.Button>
            )}
          </>
        )}
      </S.Inner>
    </MainSection>
  );
};

export default VideoHero;
